// A sessao vive em cookie HttpOnly gravado pela API: o front nao guarda nem le token.
// No localStorage ficam apenas dados de exibicao e o horario de expiracao.
export const PROVIDER_STORAGE_KEYS = [
  'ID_EMPRESA',
  'NOME_EMPRESA',
  'SOURCE_ID',
  'SESSION_EXPIRES_AT',
];

export const CLIENT_STORAGE_KEYS = [
  'NOME_USUARIO',
  'USER_CONFIRMED',
  'USER_DATA_TO_CONFIRM',
  'SESSION_EXPIRES_AT',
];

// Chaves de versoes anteriores que guardavam token ou CPF/CNPJ: sempre removidas.
export const LEGACY_STORAGE_KEYS = [
  'ID_USUARIO',
  'TOKEN_EMPRESA',
  'CNPJ',
  'user',
  'token',
];

const PROVIDER_PATH_PREFIXES = ['/provider', '/auto-login'];

export function isProviderArea(pathname = '') {
  return PROVIDER_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + '/'),
  );
}

export function clearLegacySession(storage = localStorage) {
  LEGACY_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
}

export function clearProviderSession(storage = localStorage) {
  [...PROVIDER_STORAGE_KEYS, ...LEGACY_STORAGE_KEYS].forEach((key) =>
    storage.removeItem(key),
  );
}

export function clearClientSession(storage = localStorage) {
  [...CLIENT_STORAGE_KEYS, ...LEGACY_STORAGE_KEYS].forEach((key) =>
    storage.removeItem(key),
  );
}

function saveExpiresAt(expiresAt, storage) {
  if (expiresAt !== undefined && expiresAt !== null) {
    storage.setItem('SESSION_EXPIRES_AT', expiresAt);
  }
}

// Grava os dados de exibicao do prestador a partir da resposta { company, expiresAt } da API.
export function saveProviderSession(
  { company, expiresAt },
  storage = localStorage,
) {
  clearLegacySession(storage);
  if (company.id !== undefined && company.id !== null) {
    storage.setItem('ID_EMPRESA', company.id);
  }
  storage.setItem('NOME_EMPRESA', company.tradingName || company.name || '');
  storage.setItem('SOURCE_ID', company.sourceId);
  saveExpiresAt(expiresAt, storage);
}

// Grava os dados de exibicao do cliente a partir da resposta { name, expiresAt } da API.
export function saveClientSession({ name, expiresAt }, storage = localStorage) {
  clearLegacySession(storage);
  storage.setItem('NOME_USUARIO', name || '');
  saveExpiresAt(expiresAt, storage);
}
